import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import {
  Action,
  ContactEvent,
  IContactEventType
} from "../constants/interfaces";
import api from "../utils/api";

const CONTACT_EVENT_TYPES = [
  {
    value: "CNR",
    display: "Complaints Notifications and Referrals",
    subType: ["Licence Condition Reporting", "Notification of Closure", "Other"]
  },
  {
    value: "CRC",
    display: "Correspondence",
    subType: ["Correspondence to Medicines Control"]
  },
  {
    value: "INC",
    display: "Incidents",
    subType: [
      "Dispensing error",
      "Loss of Controlled Drugs",
      "Loss of Prescription Forms",
      "Prescription Forgery",
      "Security incident",
      "Other"
    ]
  },
  {
    value: "RFI",
    display: "Request for Information",
    subType: ["General Request"]
  },
  {
    value: "SAAS",
    display: "Self Assessment Audit Submission",
    subType: ["Audit Submission"]
  }
];

interface State {
  error: Error | null;
  loading: boolean;
  contactEventTypes: IContactEventType[];
}

export function getInitialState(): State {
  return {
    loading: false,
    error: null,
    contactEventTypes: CONTACT_EVENT_TYPES
  };
}

export const contactEventTypes = {
  SUBMIT_EVENT_REQUEST: "SUBMIT_EVENT_REQUEST",
  SUBMIT_EVENT_RESPONSE: "SUBMIT_EVENT_RESPONSE",
  SET_ERROR: "SET_ERROR"
};

export const contactEventActions: any = {
  submitEvent: (
    contactEvent: ContactEvent,
    submitSuccessCallBack?: () => void
  ) => async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    dispatch({ type: contactEventTypes.SUBMIT_EVENT_REQUEST });
    try {
      await api.put(
        `/event/raiseContactEvent/${contactEvent.tempCaseId}`,
        contactEvent
      );

      if (submitSuccessCallBack) submitSuccessCallBack();
      dispatch({
        type: contactEventTypes.SUBMIT_EVENT_RESPONSE,
        error: false
      });
    } catch (e) {
      dispatch({
        type: contactEventTypes.SUBMIT_EVENT_RESPONSE,
        payload: e,
        error: true
      });
      return e;
    }
  },

  setError: (error: Error) => (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    dispatch({
      type: contactEventTypes.SET_ERROR,
      payload: error,
      error: true
    });
  }
};

export default function contactEvent(
  state = getInitialState(),
  action: Action
) {
  const { type, payload, error } = action;

  switch (type) {
    case contactEventTypes.SUBMIT_EVENT_REQUEST: {
      return { ...state, loading: true, error: null };
    }
    case contactEventTypes.SUBMIT_EVENT_RESPONSE: {
      if (error) {
        return {
          ...state,
          loading: false,
          error: payload
        };
      }
      return { ...state, loading: false, error: null };
    }

    case contactEventTypes.SET_ERROR: {
      return { ...state, loading: false, error: payload };
    }
  }
  return state;
}
